import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import SpringboardTheme, { SpringboardGlobalStyle } from 'styles/theme-springboard';
import CustomerTheme from 'styles/theme-customer';

const roleThemes = {
    portal_anon: CustomerTheme,
    portal_customer: CustomerTheme,
    portal_group: SpringboardTheme,
    portal_broker: SpringboardTheme,
    portal_staff: SpringboardTheme,
    ceio_anon: CustomerTheme,
    ceio_staff: SpringboardTheme
};

const globalStyles = {
    portal_group: SpringboardGlobalStyle,
    portal_staff: SpringboardGlobalStyle,
    ceio_staff: SpringboardGlobalStyle,
};

class SiteTheme extends Component {
    static propTypes = {
        role: PropTypes.string.isRequired,
    };

    render() {
        const { children, role } = this.props;
        const theme = roleThemes[role];
        const GlobalStyle = globalStyles[role];
        const globalStyle = GlobalStyle ? <GlobalStyle /> : null;

        if (!theme) {
            return children;
        }

        return (
            <ThemeProvider theme={theme}>
                {globalStyle}
                {children}
            </ThemeProvider>
        );
    }
}

export default SiteTheme;
